import { Button, Grid, Typography } from "@material-ui/core";
import { AttachFile, Delete } from "@material-ui/icons";
import { useRef } from "react";


export default function FileUpload(props) {
  const fileInputRef = useRef(null);

  const formatFileSize = (bytes) => {
    if (bytes === undefined) {
      return undefined;
    }

    if (bytes === 0){
      return {
        value: parseFloat((0).toFixed(2)),
        unit: 'Bytes',
        index: 0
      }
    }

    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];

    const sizeIndex = Math.floor(Math.log(bytes) / Math.log(1024));
    const sizeValue = bytes / Math.pow(1024, sizeIndex);

    return {
      value: parseFloat((sizeValue).toFixed(2)),
      unit: sizes[sizeIndex],
      index: sizeIndex
    }
  }

  const getFileSizeData = (bytes, maxRequestSize) => {
    if (bytes === 0) {
      return {
        fileValue: parseFloat((0).toFixed(2)),
        fileUnit: 'Bytes',
        limitValue: undefined,
        limitUnit: undefined,
        status: 'error'
      };
    }

    const maxSize = formatFileSize(maxRequestSize); 
    const fileSize = formatFileSize(bytes); 

    if (!maxSize) {
      return {
        fileValue: fileSize.value,
        fileUnit: fileSize.unit,
        limitValue: undefined,
        limitUnit: undefined,
        status: 'ok'
      };
    }

    let safetyBuffer = 0;

    switch (maxSize.index) {
      case 0:
        safetyBuffer = 500;
        break;
      case 1:
        safetyBuffer = 200;
        break;
      case 2: 
        safetyBuffer = 1;
        break;
      case 3:
        safetyBuffer = .001;
        break;
    }

    let status = 'error';

    if (fileSize.index < maxSize.index) {
      status = 'ok';
    } else if (fileSize.index === maxSize.index && fileSize.value <= (maxSize.value - safetyBuffer)) {
      status = 'ok';
    } else if (fileSize.index === maxSize.index && fileSize.value < maxSize.value && fileSize.value > (maxSize.value - safetyBuffer)) {
      status = 'warning';
    } else {
      status = 'error';
    }

    return {
      fileValue: fileSize.value,
      fileUnit: fileSize.unit,
      limitValue: maxSize.value,
      limitUnit: maxSize.unit,
      status
    }
  }

  const maxSizeData = props.maxRequestSize ? formatFileSize(props.maxRequestSize) : undefined;
  const fileFormattingData = props.file ? getFileSizeData(props.file.size, props.maxRequestSize) : undefined;

  let fileStatusColor = 'green';

  if (fileFormattingData?.status === 'error') {
    fileStatusColor = 'red';
  } else if (fileFormattingData?.status === 'warning') {
    fileStatusColor = 'yellow';
  }

  return (
    <>
      <Grid item xs={12} md={12} lg={12}>
        <Typography variant="h4">
          Step 1: Upload Pricing File
        </Typography>
        <Typography>
          Allowed File Types: images, .pdf, .csv, .xls, .xlsx
        </Typography>
        <Typography>
          Max File Size: {maxSizeData?.value + ' ' + maxSizeData?.unit} 
        </Typography>
      </Grid>
      <Grid item xs={12} md={12} lg={12} style={{textAlign: "center"}}>
        <input 
          ref={fileInputRef} 
          accept="image/*,.pdf,.csv,.xls,.xlsx" 
          style={{display: "none"}} 
          onChange={(e) => {
            props.setFile(e.target.files[0]);
            fileInputRef.current.value = [];
          }} 
          id="file-import-button" 
          type='file'
        />
        <label htmlFor="file-import-button" style={{display: "block"}}>
          <Button variant="contained" style={{margin: "10px 20px 20px 0px", backgroundColor: "#FFFFFF", borderRadius: "10px", border: "2px solid #bdbdbd", padding: "50px"}} component="div">
            <Typography variant="h5">
              <AttachFile fontSize="inherit" style={{display: "inline-block", verticalAlign: "middle"}}/> Choose File
            </Typography>
          </Button>
        </label>
        {props.file ? (
            <Button 
              size="large"
              variant="contained"
              endIcon={
                <Delete 
                  fontSize='small'
                  onClick={() => props.setFile(undefined)}
                />
              }
              style={{margin: "0px", backgroundColor: "#FFFFFF"}}
            >
              <span style={{color: fileStatusColor}}>
                {props.file.name} ({fileFormattingData.fileValue + ' ' + fileFormattingData.fileUnit}{fileFormattingData.limitValue ? ' / ' + fileFormattingData.limitValue + ' ' + fileFormattingData.limitUnit : ''})
              </span>
            </Button>
          ) : undefined
        }
        <div style={{margin: "20px 0px 0px"}}>
          { fileFormattingData?.status === "error" ? (
              <Typography>
                Oops! It looks like the file you imported is too large for out system right now. Please contact support for help converting this file.
              </Typography>
            ) : fileFormattingData?.status === "warning" ? (
              <Typography>
                Warning! It looks like this file is within the size limit, but it's close. This shouldn't be an issue, but please contact support if you run into any errors. Please click next to move forward.
              </Typography>
            ) : props.file ? (
              <Typography>
                Yay! It looks like we can process this file. Please click next to move forward.
              </Typography>
            ) : undefined
          }
        </div>
        
      </Grid>
      <Grid item xs={12} md={12} lg={12} style={{textAlign: "right"}}>
        <Button 
          variant="contained"
          disabled={!props.file || fileFormattingData?.status === "error"}
          onClick={() => props.continueToNextStep()}
          style={{backgroundColor: "#142e3e", color: "#28c4fc"}}
        >
          Next Step
        </Button>
      </Grid>
    </>
  )
}